// Import Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import custom modules
import { initSidebar } from './modules/sidebar';
import { initFetchForms } from './modules/fetch-forms';
import { initFetchModal } from './modules/modal-fetch';
import { initConfirmModal } from './modules/modal-confirm';
import { initToastsAndAlerts } from './modules/notifications';
import { initForms } from './modules/forms';
import { initCharts } from './modules/charts';
import { initDatatable } from './modules/datatable/datatable';
import { initAres } from './modules/ares-lookup';
import { initPasswordToggle } from './modules/password-toggle';
import { initOrderForm } from './modules/order-form';
import { initAccountingDocumentForm } from './modules/accounting-document-form';
import { initDashboard } from './modules/dashboard';
import { initProductionPlanFilter } from './modules/production-plan-filter';

// Expose initCharts globally for inline scripts that may still need it
(window as Window & typeof globalThis & { initCharts: typeof initCharts }).initCharts = initCharts;

// Import styles
import '../scss/app.scss';

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', async function () {
  // Initialize sidebar toggle
  initSidebar();

  // Initialize all custom components
  initFetchForms();
  await initFetchModal(document);
  await initConfirmModal(document);
  await initToastsAndAlerts();
  initForms(document);
  await initCharts(document);
  await initDatatable();
  await initAres(document);
  initPasswordToggle(document);
  await initOrderForm(document);
  await initAccountingDocumentForm(document);
  initDashboard();
  initProductionPlanFilter();

  // Initialize Bootstrap tooltips
  const tooltipTriggerList = document.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]');
  [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

  // Initialize Bootstrap popovers
  const popoverTriggerList = document.querySelectorAll<HTMLElement>('[data-bs-toggle="popover"]');
  [...popoverTriggerList].map((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl));
});
